import { shouldPolyfill as shouldPolyfillLocale } from '@formatjs/intl-locale/should-polyfill';
import { shouldPolyfill as shouldPolyfillNumberFormat } from '@formatjs/intl-numberformat/should-polyfill';
import { shouldPolyfill as shouldPolyfillPluralRules } from '@formatjs/intl-pluralrules/should-polyfill';

export const polyfillIntl = async () => {
    if (shouldPolyfillLocale()) {
        await import(/* webpackChunkName: "intl-locale" */ '@formatjs/intl-locale/polyfill-force');
    }
    if (shouldPolyfillPluralRules()) {
        await import(/* webpackChunkName: "intl-pluralrules" */ '@formatjs/intl-pluralrules/polyfill-force');
        await import(/* webpackChunkName: "intl-pluralrules" */ '@formatjs/intl-pluralrules/locale-data/en');
    }
    if (shouldPolyfillNumberFormat()) {
        await import(/* webpackChunkName: "intl-numberformat" */ '@formatjs/intl-numberformat/polyfill-force');
        await import(/* webpackChunkName: "intl-numberformat" */ '@formatjs/intl-numberformat/locale-data/en');
    }
};
